import { memo, useCallback, useState, type FC } from "react";
import { Popover } from "antd";
import { Smile } from "lucide-react";
import { useTranslation } from "react-i18next";
import { EMOJIS, WHATSAPP_EDITOR_KEY } from "../WhatsAppCampaignConstants";

interface EmojiPickerButtonProps {
  onPick: (_emoji: string) => void;
}

const EmojiPickerButton: FC<EmojiPickerButtonProps> = ({ onPick }) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const label = t(`${WHATSAPP_EDITOR_KEY}.form.content.format.emoji`);

  const handlePick = useCallback(
    (emoji: string) => {
      onPick(emoji);
      setIsOpen(false);
    },
    [onPick]
  );

  return (
    <Popover
      open={isOpen}
      onOpenChange={setIsOpen}
      trigger="click"
      placement="bottomLeft"
      arrow={false}
      content={
        <div className="wa-emoji-grid" role="listbox" aria-label={label}>
          {EMOJIS.map(emoji => (
            <button
              key={emoji}
              type="button"
              role="option"
              aria-selected={false}
              className="wa-emoji-grid__item"
              onClick={() => handlePick(emoji)}
            >
              {emoji}
            </button>
          ))}
        </div>
      }
    >
      <button type="button" className="wa-form__toolbar-button" aria-label={label}>
        <Smile size={16} aria-hidden />
      </button>
    </Popover>
  );
};

export default memo(EmojiPickerButton);
